import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Table } from "reactstrap";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { convertDateRange } from "../../Function/ConvertDate";
const REACT_APP_API_E_OFFICE = process.env.REACT_APP_API_E_OFFICE;
const REACT_APP_API_CORS = process.env.REACT_APP_API_CORS;

const MeetingRoom = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async (type) => {
    setLoading(true);
    const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
    const config = {
      headers: {
        Authorization: `${userEofficeAccessToken}`,
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        'Access-Control-Allow-Credentials': true
      }
    }
    const url = `${REACT_APP_API_CORS}/e-office/proxy?url=${REACT_APP_API_E_OFFICE}/api/gateway/room_booking/booking_list`;
    await axios.get(url, config).then(async response => {
      if (response?.data?.status === 'successful') {
        setData(response?.data?.data);
        setLoading(false);

      } else {
        setData([]);
        setLoading(false);

      }
    }).catch(error => {
    });
    setLoading(false);

  }

  useEffect(() => {
    const thisEffect = async () => {
      const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
      if (userEofficeAccessToken) {
        await getData();
      }
    }
    thisEffect();
  }, [])

  return (
    <div>
      <Table
        striped hover responsive
        style={{
          whiteSpace: "nowrap",
          verticalAlign: "middle"
        }}
      >
        <thead className="table-primary">
          <tr>
            <th>ชื่อห้อง</th>
            <th className="text-center">วันที่จอง</th>
            <th className="text-center">เวลาที่จอง</th>
            <th className="text-center">สถานะ</th>
          </tr>
        </thead>
        <tbody className="table-light">
          {(data.length > 0 && loading === false) ?
            data.slice(0, 5).map(i => {
              let bookingDate = convertDateRange(i?.date)
              return (
                <tr key={i} style={{ cursor: "pointer" }} onClick={() => window.open(i?.eoffice_url, "_blank")}>
                  <td className="">{i?.room_name || ''}</td>
                  <td className="text-center">{bookingDate || ''}</td>
                  <td className="text-center">{i?.time || ''}</td>
                  <td className="text-center"><Badge style={{ fontSize: '12px' }}>{i?.booking_status || ''}</Badge></td>
                </tr>
              );
            }):
            <tr key={'1'}>
              <td className="text-center" colSpan={4}>
                {loading ? <i class="fa-duotone fa-spinner-third fa-spin"></i> : 'ไม่พบข้อมูล'}
              </td>
            </tr>}
        </tbody>
      </Table>
      <div className="mt-2" style={{ textAlign: "end" }}>
        <Link to="https://eoffice.opdc.go.th/room-booking/home" target="_blank" className="btn btn-primary btn-md">
          ไประบบจองห้องประชุม <i className="mdi mdi-arrow-right ms-1"></i>
        </Link>
      </div>
    </div>
  );
};

export default MeetingRoom;
